import { actions } from 'src/constants';

export default {
  setVideoPlayed: (videoName) => ({
    type: actions.PLAYED_VIDEO,
    payload: { playedVideos: { [videoName]: true } },
  }),
};
